import React from 'react';
import PropTypes from 'prop-types';

const DownloadIcon = ({ size = 15 }) => {
    return (
        <svg stroke="currentColor" fill="currentColor" strokeWidth={0} viewBox="0 0 24 24" height={size} width={size} xmlns="http://www.w3.org/2000/svg"><path d="M19 9h-4V3H9v6H5l7 8zM4 19h16v2H4z" /></svg>
    );
};
export default DownloadIcon;

DownloadIcon.propTypes = {
    size: PropTypes.string,
};
